import { useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { PanelMenu } from "primereact/panelmenu"
import useMainMenu from "../../hooks/useMainMenu"
import {
  buildPanelMenuModel,
  renderMaterialIconMenuItemTemplate,
} from "./components/helpers/menuBuilder"

import baseStyles from "../../styles/SidebarPanelMenuBase.module.css"

export default function OrganizationMenuSidebar() {
  const navigate = useNavigate()
  const location = useLocation()

  // Pull only the Organization Management section from the shared menu config.
  const { menuItems: organizationSections, resolveMenuPath } = useMainMenu({
    includeLabels: ["Organization Management"],
  })

  // includeLabels returns at most one top-level match; render only its children
  // so this sidebar stays a simple submenu rather than an extra accordion level.
  const organizationItems = useMemo(
    () =>
      Array.isArray(organizationSections?.[0]?.items)
        ? organizationSections[0].items
        : [],
    [organizationSections],
  )

  const organizationMenuModel = useMemo(
    () =>
      // Keep route activation, icon rendering, and placeholder path resolution
      // aligned with other sidebars by using the shared menu builder.
      buildPanelMenuModel({
        items: organizationItems,
        pathname: location.pathname,
        navigate,
        itemTemplate: renderMaterialIconMenuItemTemplate,
        activeClassName: baseStyles.menuLinkActiveItem,
        resolvePath: resolveMenuPath,
        // Skip malformed entries from config snapshots.
        includeItem: ({ item }) => Boolean(item?.label),
      }),
    [location.pathname, navigate, organizationItems, resolveMenuPath],
  )

  if (!organizationMenuModel.length) {
    return null
  }

  return (
    <div className={baseStyles.menuRoot}>
      <PanelMenu
        key={`organization-menu-${location.pathname}`}
        model={organizationMenuModel}
        multiple={false}
      />
    </div>
  )
}
